module.exports = __webpack_public_path__ + "static/media/BolloCerdo.b2adc1a3.jpg";